import * as React from 'react';
import { useMemo } from 'react';
import { MinFlightPrice } from './MinFlightPrice/MinFlightPrice';
import { getMinPrices } from '../../../Results/utils';
import { SelectedFlightPrice } from './SelectedFlightPrice/SelectedFlightPrice';
import { getSeatsLeftCount } from './utils';
const FlightPrice = ({ best, singleFlight, isSelected, flight, selectedFares, passengerFares, preselectedFlightClass, canceled, onClear, hideOnlyPrice, isOrderLoading }) => {
    const [price, originalPrice, priceInMiles, hasSubsidizedFare] = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const minPrice = getMinPrices(flight.pricesForFareGroups, true, selectedFares, false, preselectedFlightClass);
        const minOriginalPrice = getMinPrices(flight.pricesForFareGroups, true, selectedFares, true, preselectedFlightClass);
        return [
            (_a = minPrice[0]) === null || _a === void 0 ? void 0 : _a.price,
            ((_c = (_b = minOriginalPrice[0]) === null || _b === void 0 ? void 0 : _b.price) === null || _c === void 0 ? void 0 : _c.amount) > ((_e = (_d = minPrice[0]) === null || _d === void 0 ? void 0 : _d.price) === null || _e === void 0 ? void 0 : _e.amount) && ((_f = minOriginalPrice[0]) === null || _f === void 0 ? void 0 : _f.price),
            (_g = minPrice[0]) === null || _g === void 0 ? void 0 : _g.priceInMiles,
            flight.pricesForFareGroups.some(group => { var _a; return (_a = group.prices) === null || _a === void 0 ? void 0 : _a.some(price => { var _a; return (_a = price.flight) === null || _a === void 0 ? void 0 : _a.subsidized; }); })
        ];
    }, [flight, preselectedFlightClass]);
    const seatsLeft = !isSelected ? getSeatsLeftCount(flight) : null;
    const [fareFamily, selectedFare] = useMemo(() => {
        var _a;
        if (!isSelected) {
            return [null, null];
        }
        const fareFamily = (_a = flight.pricesForFareGroups[0]) === null || _a === void 0 ? void 0 : _a.fareFamily;
        return [fareFamily, selectedFares[0]];
    }, [flight, selectedFares, isSelected]);
    if (selectedFare) {
        return (React.createElement(SelectedFlightPrice, { fareFamily: fareFamily, selectedFare: selectedFare, passengerFares: passengerFares, canceled: canceled, priceInMiles: priceInMiles, onClear: onClear, hideOnlyPrice: hideOnlyPrice, isOrderLoading: isOrderLoading, subsidized: hasSubsidizedFare, flightMessages: [] }));
    }
    else {
        return (React.createElement(MinFlightPrice, { singleFlight: singleFlight, best: best, originalPrice: originalPrice, price: price, priceInMiles: priceInMiles, hideOnlyPrice: hideOnlyPrice, subsidized: hasSubsidizedFare, seatsLeft: seatsLeft, flightMessages: flight.segments[0].segment.messages }));
    }
};
export default FlightPrice;
